module.exports = __webpack_public_path__ + "media/images/minus-113db01920aa8e2c915470298d2ec633.svg";